import GlyphIcon from "./GlyphIcon.mjs";

const LockIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M25,12H24V9a5.00588,5.00588,0,0,0-5-5H13A5.00588,5.00588,0,0,0,8,9v3H7a2.00591,2.00591,0,0,0-2,2V26a2.00591,2.00591,0,0,0,2,2H25a2.00591,2.00591,0,0,0,2-2V14A2.00591,2.00591,0,0,0,25,12Zm-8,8.7226V23.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V20.7226a2,2,0,1,1,2,0ZM20,12H12V9a1.01348,1.01348,0,0,1,1-1h6a1.01348,1.01348,0,0,1,1,1Z"
				{...this.props}
			/>
		);
	}
}

export default LockIcon;